export default {
  AttachFile: 'Tệp giao việc',
  More: 'Xem thêm',
  Collapse: 'Thu gọn',
  AddFile: 'Thêm tệp giao việc',
  AddFileResult: 'Thêm tệp báo cáo kết quả công việc',
  AttachFileResult: 'Tệp báo cáo kết quả công việc',
  ShareFile: 'Chia sẻ tệp giao việc',
  ShareOption: 'Tùy chọn chia sẻ với công việc con',
  ShareAll: 'Chia sẻ toàn bộ',
  Download: 'Tải xuống',
  DeleteFile: 'Xóa tệp',
  DownloadAll: 'Tải xuống toàn bộ',
  Share: 'Chia sẻ',
  IsShared: 'Đã chia sẻ với công việc con',
  NoShare: 'Không chia sẻ với công việc con',
  SearchTaskChild: 'Tìm kiếm tên công việc con',
  Validate: {
    Size: 'Tệp đính kèm không được vượt quá dung lượng 30MB',
    Type: 'Định dạng tệp không hợp lệ',
    Default: 'Không tìm thấy tệp, vui lòng thử lại',
    Preview: 'Không hỗ trợ xem trước định dạng tệp đính kèm'
  },
  ShareOptionLabel: {
    No: 'Không chia sẻ',
    All: 'Chia sẻ cho tất cả công việc con',
    Select: 'Chia sẻ cho công việc con cụ thể'
  },
  ConfirmDeleteMsg: 'Tệp đính kèm sẽ bị xóa khỏi công việc. Bạn muốn tiếp tục?',
  ConfirmDeleteTitle: 'Xóa tệp đính kèm'

}